export type UploadFileSizeConfigEntry = {
  bytes: number;
  mime: string[];
};

export type UploadFileSizeConfig = {
  images: UploadFileSizeConfigEntry;
  documents: UploadFileSizeConfigEntry;
  fonts: UploadFileSizeConfigEntry;
};


export const UPLOAD_FILE_SIZES: UploadFileSizeConfig = {
  images: {
    bytes: 20 * 1024 * 1024,
    mime: ['image/jpg', 'image/jpeg', 'image/png']
  },
  documents: {
    bytes: 200 * 1024 * 1024,
    mime: [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformat-officedocument.wordprocessingm',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/octet-stream',
      'application/vnd.ms-opentype',
      'application/msword',
      'application/vnd.ms-powerpoint',
      'text/csv',
      'text/plain'
    ]
  },
  fonts: {
    bytes: 5 * 1024 * 1024,
    mime: [
      'font/otf',
      'font/ttf',
      'application/vnd.ms-fontobject',
      'application/x-font-otf',
      'font/opentype',
      'font/sfnt',
      'application/x-font-ttf',
      'application/x-font-truetype',
      'application/font-woff',
      'application/x-font-woff',
      'font/woff',
      'font/woff2'
    ]
  }
};
